import { z } from 'zod';
import { FeatureFlagKeySchema } from '../feature-flag.js';
// =============================================================================
// Feature flags (super-admin surface)
// =============================================================================
/**
 * One catalogue flag as it stands for a given account.
 *
 * `override` and `enabled` are both present on purpose. `enabled` is the answer
 * a gate would give; `override` is how that answer was reached, and the admin
 * screen needs it to distinguish "explicitly switched on" from "on because the
 * flag went public" - the two look identical on `enabled` alone, but only the
 * first is something a colleague can turn back off.
 */
export const AccountFeatureFlagSchema = z.object({
    key: FeatureFlagKeySchema,
    label: z.string(),
    description: z.string(),
    defaultEnabled: z.boolean(),
    /** The account's explicit setting, or null when it is on the default. */
    override: z.boolean().nullable(),
    /**
     * `override ?? defaultEnabled` - what a gate reading THIS ACCOUNT'S flag
     * sees.
     *
     * An administered entity is the one case where a gate can answer differently:
     * with no override of its own it inherits `accounting` from the firm
     * administering it, so an entity can show `false` here and still have working
     * books. An override on the entity always wins, so the value is never wrong
     * about what this account has been set to - only about what it inherits.
     */
    enabled: z.boolean(),
});
export const AccountFeatureFlagListResponseSchema = z.object({
    data: z.array(AccountFeatureFlagSchema),
});
export const SetAccountFeatureFlagInputSchema = z.object({
    enabled: z.boolean(),
});
